import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

export const selectClientCargoTemplateDialogData = (state: RootState) =>
  state.app.clientCargoTemplateDialog;

export const selectInitialFormData = createSelector(
  selectClientCargoTemplateDialogData,
  (data) => data.initialFormData
);

export const selectResetFormData = createSelector(
  selectClientCargoTemplateDialogData,
  (data) => data.resetFormData
);

const selectPreviousFormData = createSelector(
  selectClientCargoTemplateDialogData,
  (data) => data.previousFormData
);

export const selectFormDataForWhenOpeningModal = createSelector(
  selectInitialFormData,
  selectPreviousFormData,
  (initial, previous) => previous || initial
);

export const selectIsSaving = createSelector(
  selectClientCargoTemplateDialogData,
  (data) => data.isSaving
);

// The revision the open template dialog saves against (DORA-441).
export const selectLoadedRevision = (state: RootState) =>
  state.app.clientCargoTemplateDialog.loadedDataRevisionNumber;

// Someone else's change clashed with the user's unsaved edits (DORA-441).
export const selectRemoteConflict = (state: RootState) =>
  state.app.clientCargoTemplateDialog.remoteConflict;
